module.exports = __webpack_public_path__ + "static/media/image_41.63c1b8d8.png";